export enum WorkbenchFabricShapeRotationStateEnum {
  Droite = 0,
  Bas = 1,
  Gauche = 2,
  Haut = 3,
}
